import { Box, CircularProgress } from "@mui/material"
import { ReactNode } from "react"

import Dialog, { DialogProps } from "./Dialog"

export type ProgressDialogProps = Omit<DialogProps, "children"> & {
  children: ReactNode
  isLoading: boolean
}

const ProgressDialog = ({ children, isLoading, ...props }: ProgressDialogProps) => {
  return (
    <Dialog {...props}>
      <Box sx={{ position: "relative" }}>
        {children}
        {isLoading && (
          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            sx={{
              background: "rgba(255, 255, 255, 0.7)",
              bottom: 0,
              left: 0,
              position: "fixed",
              right: 0,
              top: 0,
            }}
          >
            <CircularProgress sx={{ size: 24 }} />
          </Box>
        )}
      </Box>
    </Dialog>
  )
}

export default ProgressDialog
